import { ButtonView, Plugin } from 'ckeditor5';

export class FormPlugin extends Plugin {
  static get pluginName(): string {
    return 'FormPlugin';
  }

  init() {
    const editor = this.editor;

    editor.ui.componentFactory.add('formPlugin', () => {
      const button = new ButtonView();
      button.set({
        label: 'کارت توضیحات',
        withText: true,
      });

      button.on('execute', () => {
        this.showForm(editor);
      });

      return button;
    });
  }

  showForm(editor: any) {
    const form = document.createElement('div');
    form.classList.add('form-plugin-modal');
    Object.assign(form.style, {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '1rem',
      background: '#fff',
      border: '1px groove',
      borderRadius: '8px',
      zIndex: '9999',
      maxWidth: '400px',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    });

    const closeButton = document.createElement('button');
    closeButton.textContent = '✖';
    Object.assign(closeButton.style, {
        padding: '4px',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#dc3545',
        color: 'white',
        cursor: 'pointer',
        fontSize: '12px',
        position: 'relative',
        width: '20px',
        height: '20px',
    });

    closeButton.addEventListener('click', () => {
      form.remove();
      editor.editing.view.focus();
    });

    const imageContainer = document.createElement('div');
    imageContainer.classList.add('form-plugin-image-container');
    Object.assign(imageContainer.style, {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    });

    let imageUrl = '';

    const uploadButton = document.createElement('button');
    uploadButton.textContent = 'آپلود تصویر';
    Object.assign(uploadButton.style, {
      padding: '5px',
      borderRadius: '7px',
      border: '1px dashed',
      backgroundColor: 'none',
      width: '100%',
      display: 'flex',
      cursor: 'pointer',
    });




    const showImagePreview = (url: string) => {
      imageContainer.innerHTML = '';
      const img = document.createElement('img');
      img.src = url;
      Object.assign(img.style, {
        width: '70px',
        height: '70px',
        objectFit: 'cover',
        borderRadius: '4px',
      });

      const cancelButton = document.createElement('button');
      cancelButton.textContent = '✖';
      Object.assign(cancelButton.style, {
        padding: '4px',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#dc3545',
        color: 'white',
        cursor: 'pointer',
        fontSize: '12px',
        position: 'absolute',
        top: '16px',
        width: '20px',
        height: '20px',
      });

      cancelButton.addEventListener('click', () => {
        imageContainer.innerHTML = '';
        imageContainer.appendChild(uploadButton);
        imageUrl = '';
      });

      imageContainer.appendChild(img);
      imageContainer.appendChild(cancelButton);
    };

    uploadButton.addEventListener('click', () => {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = (event: any) => {
        const file = event.target.files[0];
        if (file) {
          const fileLoader = editor.plugins.get('FileRepository').createLoader(file);
          if (fileLoader) {
            fileLoader.upload().then((data: any) => {
              imageUrl = data.default;
              showImagePreview(imageUrl);
            }).catch((error: any) => {
              console.error('Upload failed:', error);
              uploadButton.textContent = 'خطا در آپلود';
            });
          }
        }
      };
      input.click();
    });

    imageContainer.appendChild(uploadButton);

    const textInput = document.createElement('input');
    textInput.placeholder = 'متن باکس';
    textInput.classList.add('form-plugin-input');
    Object.assign(textInput.style, {
      padding: '5px',
      borderRadius: '7px',
      border: '1px groove',
    });

    const linkInput = document.createElement('input');
    linkInput.placeholder = 'لینک دکمه باکس';
    linkInput.classList.add('form-plugin-input');
    Object.assign(linkInput.style, {
      padding: '5px',
      borderRadius: '7px',
      border: '1px groove',
    });

    const buttonLabelInput = document.createElement('input');
    buttonLabelInput.placeholder = 'لیبل باکس';
    buttonLabelInput.classList.add('form-plugin-input');
    Object.assign(buttonLabelInput.style, {
      padding: '5px',
      borderRadius: '7px',
      border: '1px groove',
    });

    const submitButton = document.createElement('button');
    submitButton.textContent = 'اضافه کردن';
    submitButton.classList.add('form-plugin-submit');
    Object.assign(submitButton.style, {
      padding: '5px',
      borderRadius: '7px',
      border: 'none',
      backgroundColor: '#214063',
      color: 'white',
      cursor: 'pointer',
    });
    form.appendChild(closeButton);
    form.appendChild(imageContainer);
    form.appendChild(textInput);
    form.appendChild(linkInput);
    form.appendChild(buttonLabelInput);
    form.appendChild(submitButton);

    editor.ui.view.element.appendChild(form);

    submitButton.addEventListener('click', (event) => {
      event.preventDefault();

      const text = textInput.value;
      const link = linkInput.value;
      const buttonLabel = buttonLabelInput.value;

      if (imageUrl && text && link && buttonLabel) {
        const htmlContent = `
          <style>
              @media (max-width: 768px) {
                .form-plugin-card {
                  flex-direction: column !important;
                  align-items: center !important;
                }
                .form-plugin-card-content {
                  align-items: center !important;
                  flex-direction : column !important;
                }
                .form-plugin-card-text {
                  text-align: center !important;
                }
                .form-plugin-card-button {
                  margin: 0 auto !important;
                }
              }
          </style>
          <div class="form-plugin-card" style="padding: 1rem; border-radius: 8px; display: flex; flex-direction: row; gap: 1rem; align-items: center; background-color: #f1f1f1;">
            <img src="${imageUrl}" style=" width : 120px !important; height : 120px !important; border-radius: 7px !important; object-fit: cover !important;" alt="تصویر باکس" class="box-image"/>
            <div class="form-plugin-card-content" style="width: 100%; display: flex; gap: 1rem; justify-content: space-between; align-items: center;">
              <p class="form-plugin-card-text" style="font-size: 16px; text-align: justify; margin: 0; overflow-wrap: anywhere;">${text}</p>
              <a href="${link}" target="_blank" class="form-plugin-card-button" style="text-wrap: nowrap; padding: 8px 16px; background-color: #214063; color: white; text-decoration: none; border-radius: 5px; font-weight: 500; cursor: pointer;">
                ${buttonLabel}
              </a>
            </div>
          </div>
          <br>
        `;

        editor.model.change((writer: any) => {
          const viewFragment = editor.data.processor.toView(htmlContent);
          const modelFragment = editor.data.toModel(viewFragment);
          editor.model.insertContent(modelFragment);
        });

        form.remove();
        editor.editing.view.focus();
      }
    });
  }
}